module.exports = __webpack_public_path__ + "img/right.6c16c802.png";